module.exports = __webpack_public_path__ + "img/home_img_06.4ccaf7e4.png";